import * as RadixTooltip from '@radix-ui/react-tooltip';
import styled from 'styled-components';

import { theme } from '../../../common/ui/theme';

export const Arrow = styled(RadixTooltip.Arrow)`
    fill: ${theme.colors.background.emphasis};
`;
